'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var CONFIGURATION_DOM_SELECTOR = '.js-diffusionTopicSettings';
var CONFIGURATION_HOST_PROPERTY = 'data-diffusion-host';
var CONFIGURATION_PORT_PROPERTY = 'data-diffusion-port';
var CONFIGURATION_STUB_URL_PROPERTY = 'data-diffusion-stub-url';
var CONFIGURATION_PPWR_FEED_PROPERTY = 'data-diffusion-feed-ppwr';

exports.default = function () {
    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : parent.document;

    var diffusionServerConfig = target.querySelector(CONFIGURATION_DOM_SELECTOR);
    if (!diffusionServerConfig) {
        console.error('There is no diffusion configuration node');
        return {};
    }
    return {
        host: diffusionServerConfig.getAttribute(CONFIGURATION_HOST_PROPERTY),
        port: diffusionServerConfig.getAttribute(CONFIGURATION_PORT_PROPERTY),
        url: diffusionServerConfig.getAttribute(CONFIGURATION_STUB_URL_PROPERTY),
        ppwr: diffusionServerConfig.getAttribute(CONFIGURATION_PPWR_FEED_PROPERTY)
    };
};


//////////////////
// WEBPACK FOOTER
// ./public/js/scribble/getDiffusionConfig.js
// module id = 1511
// module chunks = 0